import React, { useState } from 'react';
import Heading from 'components/common/heading/heading';
import Inputs from 'components/inputs/inputs';
import Panel from 'components/common/panel/panel';
import Popup, { ScrollingPopup, MediaPopup, ConfirmPopup } from 'components/common/popup/popup';

export default function ModalTestPage(props) {
  const [showPopup, setShowPopup] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showScrolling, setShowScrolling] = useState(false);
  const [showMedia, setShowMedia] = useState(false);

  const [popupSize, setPopupSize] = useState('sm');
  const [popupPosition, setPopupPosition] = useState('center');

  const [includeExtraHeader, setIncludeExtraHeader] = useState(false);
  const [includeFooter, setIncludeFooter] = useState(false);
  const [customizeButton, setCustomizeButton] = useState(false);

  const launch = (id) => {
    switch (id) {
      case 1:
        setShowPopup(true);
        setIncludeFooter(false);
        break;
      case 2:
        setShowPopup(true);
        setIncludeFooter(true);
        break;
      case 3:
        setShowConfirm(true);
        setIncludeFooter(false);
        setCustomizeButton(false);
        break;
      case 4:
        setShowConfirm(true);
        setIncludeFooter(true);
        setCustomizeButton(true);
        break;
      case 5:
        setShowScrolling(true);
        setIncludeExtraHeader(false);
        setIncludeFooter(false);
        break;
      case 6:
        setShowScrolling(true);
        setIncludeExtraHeader(true);
        setIncludeFooter(true);
        break;
      case 7:
        setShowScrolling(true);
        setIncludeExtraHeader(true);
        setIncludeFooter(false);
        break;
      case 8:
        setShowScrolling(true);
        setIncludeExtraHeader(false);
        setIncludeFooter(true);
        break;
      case 9:
        setShowMedia(true);
        break;
      default:
        break;
    }
  };

  const renderExtraHeader = () => {
    if (includeExtraHeader) {
      return <Inputs.Text placeholder='Search' />;
    }
    return null;
  };

  const renderFooter = (onClose) => {
    if (includeFooter) {
      return (
        <div className='d-flex justify-content-between align-items-center w-100'>
          <span className='badge badge-light-app'>Label</span>
          <Inputs.Button variant='default' label='Close' iconClass='icons8-delete' onClick={onClose} />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <Heading>
        <div>
          <a href='/Developers/Test/Components' className='btn btn-link'>View Components Test</a>
          <a href='/Developers/Test/Data' className='btn btn-link'>View Data Test</a>
          <a href='/Developers/Test/Forms' className='btn btn-link'>View Forms Test</a>
          <div className='btn btn-none text-dark text-thick'>Modals Test</div>
        </div>
      </Heading>

      <div className='row justify-content-center mx-0 mt-4'>
        <div className='col-md-12 col-xl-10'>

          <Panel>
            <Panel.Header>Modals</Panel.Header>
            <Panel.Body>
              <div>
                <h5>Normal</h5>
                <div className='mb-2'>
                  <Inputs.Select value={popupSize} onValueChange={setPopupSize} style={{ width: 200, marginRight: 16 }}>
                    <option value='sm'>Small</option>
                    <option value='md'>Medium</option>
                    <option value='lg'>Large</option>
                    <option value='xl'>Extra Large</option>
                  </Inputs.Select>
                  <Inputs.Select value={popupPosition} onValueChange={setPopupPosition} style={{ width: 200 }}>
                    <option value='center'>Center</option>
                    <option value='fullscreen'>Fullscreen</option>
                    <option value='topscreen'>Topscreen</option>
                  </Inputs.Select>
                </div>
                <div>
                  <Inputs.Button variant='app' className='mr-2' label='Launch Normal' onClick={() => launch(1)} />
                  <Inputs.Button variant='app' className='mr-2' label='Launch Normal (with Footer)' onClick={() => launch(2)} />
                </div>
                <div>
                  <Inputs.Button variant='secondary' className='mr-2' label='Launch Confirm' onClick={() => launch(3)} />
                  <Inputs.Button variant='secondary' className='mr-2' label='Launch Confirm (Custom Buttons)' onClick={() => launch(4)} />
                </div>
              </div>
              <div className='mt-3'>
                <h5>Scrolling</h5>
                <Inputs.Button variant='success' className='mr-2' label='Launch Scrolling' onClick={() => launch(5)} />
                <Inputs.Button variant='success' className='mr-2' label='Launch Scrolling (with Header & Footer)' onClick={() => launch(6)} />
                <Inputs.Button variant='success' className='mr-2' label='Launch Scrolling (with Header)' onClick={() => launch(7)} />
                <Inputs.Button variant='success' className='mr-2' label='Launch Scrolling (with Footer)' onClick={() => launch(8)} />
              </div>
              <div className='mt-3'>
                <h5>Media</h5>
                <Inputs.Button variant='warning' className='mr-2' label='Launch Media' onClick={() => launch(9)} />
              </div>
            </Panel.Body>
          </Panel>

          <Popup
            title='Popup'
            show={showPopup}
            size={popupSize}
            position={popupPosition}
            onClose={() => setShowPopup(false)}
            footer={renderFooter(() => setShowPopup(false))}
          >
            It seems to be working
          </Popup>

          <ConfirmPopup
            title='Confirm Popup'
            show={showConfirm}
            size={popupSize}
            position={popupPosition}
            onClose={() => setShowConfirm(false)}
            acceptLabel={customizeButton ? 'Perfect' : null}
            acceptIconClass={customizeButton ? 'icons8-checkmark' : null}
            acceptVariant={customizeButton ? 'success' : null}
            declineLabel={customizeButton ? 'Not at all!' : null}
            declineIconClass={customizeButton ? 'icons8-logout-rounded-up' : null}
            declineVariant={customizeButton ? 'danger' : null}
          >
            How is it working?
          </ConfirmPopup>

          <ScrollingPopup
            title='Scrolling Popup'
            show={showScrolling}
            onClose={() => setShowScrolling(false)}
            header={renderExtraHeader()}
            footer={renderFooter(() => setShowScrolling(false))}
          >
            <samp className='small'>
              {log.split('\n').map((item, index) => <div key={index}>{item}</div>)}
            </samp>
          </ScrollingPopup>

          <MediaPopup
            title='Media Popup'
            show={showMedia}
            onClose={() => setShowMedia(false)}
          >
            <iframe src={fileURL} title='PDF' height='100%' width='100%' style={{ height: '100%', width: '100%', display: 'block', borderWidth: 0 }}></iframe>
          </MediaPopup>

          <div>
            TODO
            <ol>
              <li>Add header variants</li>
              <li>Media popup can be removed and made into a new size (full screen all the time)</li>
            </ol>
          </div>

        </div>
      </div>
    </>
  );
}



const fileURL = 'https://static.positouchcloud.com/pr/1d4d3f01b5624d92ae1f4edaac349cc7';

const log = `***  Installation Started 10/24/2019 13:17  ***
Title: Mozart Upgrade Installation
Source: C:\\SC\\SoftwareUpdate\\MZA\\19102430\\UPDATE\\Mozart_Upgrade_Installer_[v2_0_0_5].exe | 10-23-2019 | 16:42:48 | 18886370


Navigator Version: 3.0.0.4
Navigator working path is C:\\SC.
Setting POS Driver Path to C:\\SC
SPCWIN Address Not Found!
Spcwin.exe and Version.sys are incompatible!
Existing SpcWin: 6.4|09/03/19 12:26:12

File Overwrite: C:\\SC\\WAITSECS.EXE | 09-08-2011 | 08:30:16 | 1.0.0.0 | 24576 | 46e7c4fc


**********************************************************************************************************************

Closing Mozart Services...

Moving Exisiting Mozart folder to C:\\Mozart Backup
File Overwrite: C:\\Mozart Backup\\Backup\\Mozart.Brand.Plugins.POSitouch.config
File Overwrite: C:\\Mozart Backup\\bin\\consumerInfo.dat
File Overwrite: C:\\Mozart Backup\\bin\\FastColoredTextBox.dll
File Overwrite: C:\\Mozart Backup\\bin\\InstallMozartService.cmd
File Overwrite: C:\\Mozart Backup\\bin\\InstallMozartServiceUnderPosiLiveAgent.cmd
File Overwrite: C:\\Mozart Backup\\bin\\log4net.config
File Overwrite: C:\\Mozart Backup\\bin\\log4net.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Data.Sqlite.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Diagnostics.Tracing.EventSource.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.EntityFrameworkCore.Abstractions.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.EntityFrameworkCore.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.EntityFrameworkCore.Relational.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.EntityFrameworkCore.Sqlite.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Caching.Abstractions.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Caching.Memory.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Configuration.Abstractions.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.DependencyInjection.Abstractions.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.DependencyInjection.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Logging.Abstractions.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Logging.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Options.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Microsoft.Extensions.Primitives.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Biz.EventManager.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Biz.Events.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Brand.Interfaces.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Brand.Plugins.POSitouch.config
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Brand.Plugins.POSitouch.config_sk
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Brand.Plugins.POSitouch.config_sk_update1
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Core.Interfaces.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Core.PluginController.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Objects.Data.Core.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Objects.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Plugin.BrandManager.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Plugin.DBManager.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Plugin.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Plugin.LogManager.dll
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Plugin.MessageManager.dll
File Overwrite: C:\\Mozart Backup\\bin\\Mozart.Plugin.QueueManager.dll
File Overwrite: C:\\Mozart Backup\\bin\\MozartAgent.exe
File Overwrite: C:\\Mozart Backup\\bin\\MozartAgent.exe.config
File Overwrite: C:\\Mozart Backup\\bin\\MozartManager.exe
File Overwrite: C:\\Mozart Backup\\bin\\netstandard.dll
File Overwrite: C:\\Mozart Backup\\bin\\Newtonsoft.Json.DLL
File Overwrite: C:\\Mozart Backup\\bin\\RabbitMQ.Client.DLL
File Overwrite: C:\\Mozart Backup\\bin\\Remotion.Linq.DLL
File Overwrite: C:\\Mozart Backup\\bin\\SQLitePCLRaw.batteries_green.dll
File Overwrite: C:\\Mozart Backup\\bin\\SQLitePCLRaw.batteries_v2.dll
File Overwrite: C:\\Mozart Backup\\bin\\SQLitePCLRaw.core.DLL
File Overwrite: C:\\Mozart Backup\\bin\\SQLitePCLRaw.provider.e_sqlite3.DLL
File Overwrite: C:\\Mozart Backup\\bin\\System.Collections.Immutable.DLL
File Overwrite: C:\\Mozart Backup\\bin\\System.ComponentModel.Annotations.DLL
File Overwrite: C:\\Mozart Backup\\bin\\System.Diagnostics.DiagnosticSource.DLL
File Overwrite: C:\\Mozart Backup\\bin\\System.Interactive.Async.DLL
File Overwrite: C:\\Mozart Backup\\bin\\System.IO.Compression.FileSystem.dll
File Overwrite: C:\\Mozart Backup\\bin\\System.Net.Http.DLL
File Overwrite: C:\\Mozart Backup\\bin\\System.Runtime.InteropServices.RuntimeInformation.dll
File Overwrite: C:\\Mozart Backup\\bin\\System.Runtime.Serialization.Xml.dll
File Overwrite: C:\\Mozart Backup\\bin\\System.ValueTuple.dll
File Overwrite: C:\\Mozart Backup\\bin\\UninstallMozartService.cmd
File Overwrite: C:\\Mozart Backup\\bin\\x64\\e_sqlite3.dll
File Overwrite: C:\\Mozart Backup\\bin\\x64\\SQLite.Interop.dll
File Overwrite: C:\\Mozart Backup\\bin\\x86\\e_sqlite3.dll
File Overwrite: C:\\Mozart Backup\\bin\\x86\\SQLite.Interop.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\appsettings.Development.json
File Overwrite: C:\\Mozart Backup\\gui\\api\\appsettings.json
File Overwrite: C:\\Mozart Backup\\gui\\api\\e_sqlite3.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\hostfxr.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\hostpolicy.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\InstallAPI.cmd
File Overwrite: C:\\Mozart Backup\\gui\\api\\Microsoft.AspNetCore.Hosting.WindowsServices.DLL
File Overwrite: C:\\Mozart Backup\\gui\\api\\Microsoft.Data.Sqlite.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\Microsoft.EntityFrameworkCore.Sqlite.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\Microsoft.Extensions.Logging.EventLog.DLL
File Overwrite: C:\\Mozart Backup\\gui\\api\\Mozart.Api.deps.json
File Overwrite: C:\\Mozart Backup\\gui\\api\\Mozart.Api.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\Mozart.Api.exe
File Overwrite: C:\\Mozart Backup\\gui\\api\\Mozart.Api.runtimeconfig.json
File Overwrite: C:\\Mozart Backup\\gui\\api\\Mozart.Objects.Data.Core.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\Mozart.Objects.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\Newtonsoft.Json.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\SQLitePCLRaw.batteries_green.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\SQLitePCLRaw.batteries_v2.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\SQLitePCLRaw.core.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\SQLitePCLRaw.provider.e_sqlite3.DLL
File Overwrite: C:\\Mozart Backup\\gui\\api\\startAPI.cmd
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Collections.Concurrent.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Collections.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Diagnostics.EventLog.DLL
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Resources.ResourceManager.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Runtime.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Runtime.InteropServices.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.ServiceProcess.ServiceController.DLL
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Text.Encoding.dll
File Overwrite: C:\\Mozart Backup\\gui\\api\\System.Threading.AccessControl.DLL
File Overwrite: C:\\Mozart Backup\\gui\\api\\UninstallAPI.cmd
File Overwrite: C:\\Mozart Backup\\gui\\ui\\app.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\asset-manifest.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\favicon.ico
File Overwrite: C:\\Mozart Backup\\gui\\ui\\index.html
File Overwrite: C:\\Mozart Backup\\gui\\ui\\install.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\installService.bat
File Overwrite: C:\\Mozart Backup\\gui\\ui\\manifest.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\package-lock.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\service-worker.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\settings.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\uninstall.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\uninstallService.bat
File Overwrite: C:\\Mozart Backup\\gui\\ui\\daemon\\mozartuiservice.err.log
File Overwrite: C:\\Mozart Backup\\gui\\ui\\daemon\\mozartuiservice.exe
File Overwrite: C:\\Mozart Backup\\gui\\ui\\daemon\\mozartuiservice.exe.config
File Overwrite: C:\\Mozart Backup\\gui\\ui\\daemon\\mozartuiservice.out.log
File Overwrite: C:\\Mozart Backup\\gui\\ui\\daemon\\mozartuiservice.wrapper.log
File Overwrite: C:\\Mozart Backup\\gui\\ui\\daemon\\mozartuiservice.xml
File Overwrite: C:\\Mozart Backup\\gui\\ui\\images\\doordash_logo.png
File Overwrite: C:\\Mozart Backup\\gui\\ui\\images\\grubhub_logo.png
File Overwrite: C:\\Mozart Backup\\gui\\ui\\images\\menufy_logo.png
File Overwrite: C:\\Mozart Backup\\gui\\ui\\images\\takeout7_logo.png
File Overwrite: C:\\Mozart Backup\\gui\\ui\\images\\ubereats_logo.PNG
File Overwrite: C:\\Mozart Backup\\gui\\ui\\images\\unknown.png
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\accepts\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\accepts\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\accepts\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\accepts\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\accepts\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\array-flatten\\array-flatten.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\array-flatten\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\array-flatten\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\array-flatten\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\lib\\read.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\lib\\types\\json.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\lib\\types\\raw.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\lib\\types\\text.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\body-parser\\lib\\types\\urlencoded.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\bytes\\History.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\bytes\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\bytes\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\bytes\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\bytes\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-disposition\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-disposition\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-disposition\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-disposition\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-disposition\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-type\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-type\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-type\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-type\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\content-type\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie-signature\\.npmignore
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie-signature\\History.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie-signature\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie-signature\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\cookie-signature\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\.coveralls.yml
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\.eslintrc
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\.npmignore
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\.travis.yml
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\CHANGELOG.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\component.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\karma.conf.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\Makefile
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\node.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\src\\browser.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\src\\debug.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\src\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\src\\inspector-log.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\debug\\src\\node.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\History.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\lib\\browser\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\lib\\compat\\callsite-tostring.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\lib\\compat\\event-listener-count.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\depd\\lib\\compat\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\destroy\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\destroy\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\destroy\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\destroy\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ee-first\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ee-first\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ee-first\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ee-first\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\encodeurl\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\encodeurl\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\encodeurl\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\encodeurl\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\encodeurl\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\escape-html\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\escape-html\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\escape-html\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\escape-html\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\etag\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\etag\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\etag\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\etag\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\etag\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\History.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\application.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\express.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\request.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\response.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\utils.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\view.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\middleware\\init.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\middleware\\query.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\router\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\router\\layer.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\express\\lib\\router\\route.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\finalhandler\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\finalhandler\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\finalhandler\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\finalhandler\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\finalhandler\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\forwarded\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\forwarded\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\forwarded\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\forwarded\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\forwarded\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\fresh\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\fresh\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\fresh\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\fresh\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\fresh\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\http-errors\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\http-errors\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\http-errors\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\http-errors\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\http-errors\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\Changelog.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\dbcs-codec.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\dbcs-data.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\internal.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\sbcs-codec.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\sbcs-data-generated.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\sbcs-data.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\utf16.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\utf7.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\big5-added.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\cp936.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\cp949.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\cp950.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\eucjp.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\gb18030-ranges.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\gbk-added.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\encodings\\tables\\shiftjis.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\lib\\bom-handling.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\lib\\extend-node.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\lib\\index.d.ts
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\lib\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\iconv-lite\\lib\\streams.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\inherits\\inherits.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\inherits\\inherits_browser.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\inherits\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\inherits\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\inherits\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ipaddr.js\\ipaddr.min.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ipaddr.js\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ipaddr.js\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ipaddr.js\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ipaddr.js\\lib\\ipaddr.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ipaddr.js\\lib\\ipaddr.js.d.ts
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\media-typer\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\media-typer\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\media-typer\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\media-typer\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\media-typer\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\merge-descriptors\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\merge-descriptors\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\merge-descriptors\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\merge-descriptors\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\merge-descriptors\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\methods\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\methods\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\methods\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\methods\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\methods\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\.npmignore
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\CHANGELOG.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\cli.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\mime.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\types.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\src\\build.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime\\src\\test.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-db\\db.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-db\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-db\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-db\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-db\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-db\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-types\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-types\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-types\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-types\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\mime-types\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\.travis.yml
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\readme.markdown
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\example\\parse.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\bool.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\dash.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\default_bool.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\dotted.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\long.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\num.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\parse.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\parse_modified.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\short.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\minimist\\test\\whitespace.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ms\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ms\\license.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ms\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\ms\\readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\lib\\charset.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\lib\\encoding.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\lib\\language.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\negotiator\\lib\\mediaType.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\elevate\\elevate.cmd
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\elevate\\elevate.vbs
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\sudowin\\LICENSE.txt
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\sudowin\\sudo.exe
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\sudowin\\sudo.exe.config
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\sudowin\\Sudowin.Common.dll
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\winsw\\winsw.exe
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\bin\\winsw\\winsw.exe.config
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\binaries.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\cmd.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\daemon.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\eventlog.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\node-windows.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\winsw.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\node-windows\\lib\\wrapper.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\on-finished\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\on-finished\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\on-finished\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\on-finished\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\on-finished\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\.travis.yml
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\readme.markdown
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\bool.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\boolean_double.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\boolean_single.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\default_hash.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\default_singles.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\divide.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\line_count.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\line_count_options.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\line_count_wrap.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\nonopt.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\reflect.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\short.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\string.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\usage-options.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\example\\xup.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\dash.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\parse.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\parse_modified.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\short.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\usage.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\whitespace.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\_.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\_\\argv.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\optimist\\test\\_\\bin.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\parseurl\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\parseurl\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\parseurl\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\parseurl\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\parseurl\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\path-to-regexp\\History.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\path-to-regexp\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\path-to-regexp\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\path-to-regexp\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\path-to-regexp\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\proxy-addr\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\proxy-addr\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\proxy-addr\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\proxy-addr\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\proxy-addr\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\.editorconfig
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\.eslintignore
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\.eslintrc
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\CHANGELOG.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\dist\\qs.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\lib\\formats.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\lib\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\lib\\parse.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\lib\\stringify.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\lib\\utils.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\test\\.eslintrc
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\test\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\test\\parse.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\test\\stringify.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\qs\\test\\utils.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\range-parser\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\range-parser\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\range-parser\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\range-parser\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\range-parser\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\raw-body\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\raw-body\\index.d.ts
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\raw-body\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\raw-body\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\raw-body\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\raw-body\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safe-buffer\\index.d.ts
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safe-buffer\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safe-buffer\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safe-buffer\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safe-buffer\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\dangerous.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\Porting-Buffer.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\Readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\safer.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\safer-buffer\\tests.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\node_modules\\ms\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\node_modules\\ms\\license.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\node_modules\\ms\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\send\\node_modules\\ms\\readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\serve-static\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\serve-static\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\serve-static\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\serve-static\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\serve-static\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\setprototypeof\\index.d.ts
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\setprototypeof\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\setprototypeof\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\setprototypeof\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\setprototypeof\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\setprototypeof\\test\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\statuses\\codes.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\statuses\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\statuses\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\statuses\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\statuses\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\statuses\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\toidentifier\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\toidentifier\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\toidentifier\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\toidentifier\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\type-is\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\type-is\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\type-is\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\type-is\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\type-is\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\unpipe\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\unpipe\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\unpipe\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\unpipe\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\unpipe\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\utils-merge\\.npmignore
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\utils-merge\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\utils-merge\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\utils-merge\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\utils-merge\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\vary\\HISTORY.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\vary\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\vary\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\vary\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\vary\\README.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\index.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\README.markdown
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\example\\center.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\example\\meat.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\test\\break.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\test\\idleness.txt
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\wordwrap\\test\\wrap.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\.npmignore
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\.travis.yml
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\LICENSE
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\package.json
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\readme.md
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\examples\\examples.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\examples\\server.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\lib\\escapeForXML.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\lib\\xml.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\node_modules\\xml\\test\\xml.test.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\css\\main.504e0883.css
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\css\\main.504e0883.css.map
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\js\\main.684a6907.js
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\js\\main.684a6907.js.map
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\media\\streamline-30px-filled-in.1523406d.svg
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\media\\streamline-30px-filled-in.1e23173c.eot
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\media\\streamline-30px-filled-in.caf237bd.ttf
File Overwrite: C:\\Mozart Backup\\gui\\ui\\static\\media\\streamline-30px-filled-in.f21df499.woff
File Overwrite: C:\\Mozart Backup\\POSitouchPlugin\\Microsoft.Diagnostics.Tracing.EventSource.dll
File Overwrite: C:\\Mozart Backup\\POSitouchPlugin\\Mozart.Brand.Plugins.POSitouch.dll
File Overwrite: C:\\Mozart Backup\\POSitouchPlugin\\RDC_UTIL.DLL
File Overwrite: C:\\Mozart Backup\\POSitouchPlugin\\System.IO.Compression.DLL
File Overwrite: C:\\Mozart Backup\\POSitouchPlugin\\System.IO.Compression.FileSystem.dll

Installing Mozart Directories and Files...
File Overwrite: C:\\Mozart\\gui\\ui\\installService.bat | 08-26-2019 | 15:49:18 | | 169 | 1c2f3a95
File Overwrite: C:\\Mozart\\gui\\ui\\uninstallService.bat | 08-27-2019 | 09:17:54 | | 47 | c56243f1

Start Mozart Services...

**********************************************************************************************************************


***  Installation Completed  10/24/19 13:18:30 ***
`;